var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"admin_modal_form","lazy":"","hide-footer":"","centered":"","size":"lg"}},[_c('template',{slot:"modal-title"},[(_vm.id_to_edit)?_c('i',{staticClass:"far fa-pencil"}):_c('i',{staticClass:"far fa-plus fa-lg"}),_vm._v("\n    "+_vm._s(_vm.id_to_edit ? 'Edition de la fiche' : 'Nouvelle fiche')+"\n  ")]),_vm._v(" "),_c(_vm.config.form_component_name,{tag:"component",attrs:{"id_to_edit":_vm.id_to_edit}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-885e5486","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Global/AdminModalForm.vue
// module id = 509
// module chunks = 0